import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';

const StnReportPage = createLazyPage(
  () => import('@app/modules/stnReports/pages/StnReportPage')
);

export const stnReportRoutes: AppRouteDefinition[] = [
  {
    key: 'back-office-stn-report',
    path: 'back-office/stn',
    element: <StnReportPage />,
  },
];
